import { render, staticRenderFns } from "./FormActionButtons.vue?vue&type=template&id=0c73bde1&scoped=true&"
import script from "./FormActionButtons.vue?vue&type=script&lang=js&"
export * from "./FormActionButtons.vue?vue&type=script&lang=js&"
import style0 from "./FormActionButtons.vue?vue&type=style&index=0&id=0c73bde1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c73bde1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
